import requests from "../httpService";

const CustomRequests = {
  mainImageUploader(file) {
    return requests.post(`/file/upload-unique`, file, null);
  },
};

export default CustomRequests;
